var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.shouldShow)?_c('div',{staticClass:"board-quick-tip d-flex align-center",on:{"click":_vm.onDismiss}},[_c('span',{staticClass:"board-quick-tip__bulb mr-2"}),_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }